import { MapPin, MapTrifold, Phone } from "@phosphor-icons/react";
import { Link } from "react-router-dom";
import { navLinks, siteInfo } from "../data/siteData";
import { BrandMark } from "./BrandMark";

export function SiteFooter() {
  return (
    <footer className="px-4 pb-8 pt-14">
      <div className="mx-auto max-w-[1440px] rounded-[2.4rem] border border-white/72 bg-white/64 p-6 shadow-[0_28px_74px_-50px_rgba(27,53,52,0.52)] backdrop-blur-2xl">
        <div className="grid gap-8 lg:grid-cols-[minmax(0,0.9fr)_minmax(0,0.55fr)_minmax(0,0.55fr)]">
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <BrandMark />
              <div>
                <p className="text-base font-semibold tracking-tight text-stone-950">
                  {siteInfo.brand}
                </p>
                <p className="text-sm text-stone-500">{siteInfo.subtitle}</p>
              </div>
            </div>
            <p className="max-w-[42ch] text-sm leading-7 text-stone-600">
              Узбекская кухня с крепкой подачей, понятной доставкой и отдельным
              сценарием для семейных, офисных и праздничных столов.
            </p>
          </div>

          <div className="space-y-3">
            <p className="text-sm uppercase tracking-[0.18em] text-teal-800">Разделы</p>
            <div className="grid gap-2 text-sm text-stone-600">
              {navLinks.map((item) => (
                <Link key={item.to} to={item.to} className="transition duration-300 hover:text-stone-950">
                  {item.label}
                </Link>
              ))}
            </div>
          </div>

          <div className="space-y-3">
            <p className="text-sm uppercase tracking-[0.18em] text-teal-800">Контакты</p>
            <div className="grid gap-3 text-sm leading-7 text-stone-600">
              <a
                href={siteInfo.phoneHref}
                className="inline-flex items-start gap-2 transition duration-300 hover:text-stone-950"
              >
                <Phone size={16} className="mt-1 text-teal-700" />
                {siteInfo.phone}
              </a>
              <a
                href={siteInfo.mapHref}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-start gap-2 transition duration-300 hover:text-stone-950"
              >
                <MapPin size={16} className="mt-1 text-teal-700" />
                {siteInfo.address}
              </a>
              <a
                href={siteInfo.mapHref}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-2 text-teal-800 transition duration-300 hover:text-teal-950"
              >
                <MapTrifold size={16} />
                {siteInfo.mapLabel}
              </a>
              <span>{siteInfo.hours}</span>
              <div className="flex flex-wrap gap-4">
                <Link to="/privacy" className="transition duration-300 hover:text-stone-950">
                  Политика
                </Link>
                <Link to="/offer" className="transition duration-300 hover:text-stone-950">
                  Оферта
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8 border-t border-teal-900/8 pt-4 text-sm text-stone-500">
          {siteInfo.brand}. Halal kitchen, доставка по временным слотам и большие
          заказы по предварительному согласованию.
        </div>
      </div>
    </footer>
  );
}
